module.exports = __webpack_public_path__ + "img/04s-Shop_651.1fdb0547.jpg";